<div> current user: {{ currentUser }} </div>
<div *ngFor="let user of users">
   <div>User: {{ user.id }}</div>
   <div>Display Name: {{ user.displayName }}</div>
   <a [routerLink]="['/users/' + user.id]" class="button-link legacy"> <i class="material-icons"> arrow_forward </i> view </a>
</div>
 